export var VELT_SDK_VERSION = '4.6.0-beta.7';
export var VELT_SDK_INIT_EVENT = 'onVeltInit';
export var VELT_TAB_ID = 'veltTabId';
// integrity map for the Velt SDK
// Note: generate integrity hashes with: https://www.srihash.org/
export var INTEGRITY_MAP = {
    '4.6.0-beta.7': 'sha384-w7F4QM2nNj2v5ZjTBq2peyUCcChvMfpzYSEqmq3ekczFcfnIEccUjocPIp9EkDOm',
};
